import React, { useLayoutEffect, useState } from "react";
import Title from "./Title";
import { database, ref, get } from "../firebase";
import Image from "./Image";

function History({ path, containerClassNames = "text-white", defaultImage }) {
    const [historyItems, setHistoryItems] = useState([]);
    const [technology, setTechnology] = useState({});

    useLayoutEffect(() => {
        const dbRefHistory = ref(database, `/${path}/history`);
        const dbRefTechnology = ref(database, `/${path}/technology`);

        get(dbRefHistory)
            .then((snapshot) => {
                if (snapshot.exists()) {
                    setHistoryItems(snapshot.val());
                } else {
                    console.log("No data available");
                }
            })
            .catch((error) => {
                console.error(error);
            });

        get(dbRefTechnology)
            .then((snapshot) => {
                if (snapshot.exists()) {
                    setTechnology(snapshot.val());
                } else {
                    console.log("No data available");
                }
            })
            .catch((error) => {
                console.error(error);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div
            className={`${containerClassNames} flex justify-center historyItems-center px-6 xl:px-24 pt-14 xl:pt-36 flex-col`}
        >
            <div className="mb-8 xl:mb-24 text-center">
                <Title title={"ІСТОРІЯ ЗАСНУВАННЯ КОЛЕКЦІЇ"} />
            </div>

            <div className="flex justify-center lg:justify-between flex-col lg:flex-row w-fit lg:w-full mb-12 gap-0 lg:gap-7">
                {historyItems.map((historyItem, index) => {
                    return (index + 1) % 2 ? (
                        <div className="flex justify-center items-center flex-col w-auto lg:w-[490px] xl:w-[582px] font-extralight text-base lg:text-[26px] leading-7 word-space-10px">
                            <div className="w-fit font-extralight text-justify lg:text-wrap">
                                <span className="">
                                    {historyItem?.description}
                                </span>
                            </div>
                            <div className="flex justify-center w-full my-12 lg:mt-12 lg:mb-0">
                                <Image
                                    highQualitySrc={historyItem?.image}
                                    lowQualitySrc={defaultImage}
                                    alt="First Ring"
                                />
                            </div>
                        </div>
                    ) : (
                        <div className="flex flex-col-reverse lg:flex-col justify-center items-center w-auto lg:w-[490px] xl:w-[582px] font-extralight text-base lg:text-[26px] leading-7 word-space-10px">
                            <div className="flex justify-center w-full my-12 lg:mb-12 lg:mt-0">
                                <Image
                                    highQualitySrc={historyItem?.image}
                                    lowQualitySrc={defaultImage}
                                    alt="Second Ring"
                                />
                            </div>
                            <div className="flex flex-col text-justify lg:text-wrap">
                                <span>{historyItem?.description}</span>
                            </div>
                        </div>
                    );
                })}
            </div>

            <div className="mb-12 xl:mb-24 flex flex-col">
                <Title title={technology.title} classNames={"mb-12"} />

                <span className="word-space-10px text-base lg:text-[26px] leading-7 font-extralight text-justify">
                    {technology.description}
                </span>
            </div>
        </div>
    );
}

export default History;
